import type * as React from "react";

import { cn } from "@/lib/utils";

/** C25 批1(P5)⭐:AI 渐变描边卡——白底 r16 + 2px 橙→粉紫渐变边 + [AI] 黑方标。
 * 用途纪律:凡 **LLM 产出**(CX Score/判官结论/归因)用此形态,与人工/确定性内容一眼区分。 */
export function AiCard({
	title,
	children,
	className,
}: {
	title?: React.ReactNode;
	children: React.ReactNode;
	className?: string;
}) {
	return (
		<div
			className={cn(
				"rounded-2xl bg-gradient-to-r from-[#F7A46B] via-[#EB5A0C]/70 to-[#C94BD4] p-[2px]",
				className,
			)}
		>
			<div className="rounded-[14px] bg-surface-card p-4">
				{title !== undefined ? (
					<div className="flex items-center gap-2 pb-1.5">
						<AiMark />
						<span className="text-base font-semibold text-text-primary">{title}</span>
					</div>
				) : null}
				<div className="text-sm leading-6 text-text-secondary">{children}</div>
			</div>
		</div>
	);
}

export function AiMark({ className }: { className?: string }) {
	return (
		<span
			className={cn(
				"inline-flex h-5 w-5 items-center justify-center rounded-md bg-brand-primary font-mono text-[10px] font-bold text-text-inverse",
				className,
			)}
			aria-label="AI 生成"
		>
			AI
		</span>
	);
}
